import React from 'react';
import {FormattedMessage} from 'react-intl';
import {bool, func, string, number} from 'prop-types';
import BasicModal from 'components/common/BasicModal';
import {EmptyFunc} from 'utils/DBUtils';

const RevokePointsModal = props => (
  <BasicModal
    dimmer
    header={<FormattedMessage id='userManagement.userDetail.modals.revokePoints.header' values={{email: props.email}} />}
    specialType='delete-modal caution-modal centered-modal fadeInUp animResponse'
    modalSize='small'
    actions={[
      {
        label: <FormattedMessage id='userManagement.userDetail.modals.revokePoints.cancel' />,
        action: props.cancel,
        isDisabled: props.revoking,
        displayType: 'menu-item'
      },
      {
        label: <FormattedMessage id='userManagement.userDetail.modals.revokePoints.submit' />,
        loading: props.revoking,
        action: props.confirm,
        displayType: 'button',
        primaryCheck: true
      }
    ]}
    open={props.modalOpen}
    onClose={props.revoking ? EmptyFunc : props.cancel}>
    <FormattedMessage
      id='userManagement.userDetail.modals.revokePoints.message'
      values={{amount: props.amount, email: props.email}} />
  </BasicModal>
);

RevokePointsModal.propTypes = {
  revoking: bool,
  modalOpen: bool,
  confirm: func.isRequired,
  cancel: func.isRequired,
  email: string,
  amount: number
};

export default RevokePointsModal;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/modals/RevokePointsModal/RevokePointsModal.jsx